// extracted by mini-css-extract-plugin
export default {"root":"shared-module__root--tnRsc","fontSmoothing":"shared-module__fontSmoothing--ALRnF","SubNav__spacer":"shared-module__SubNav__spacer--Ou6GW"};